import axios from "axios";
import { API } from ".";

export const getCompanyDetail = () => {
  return axios.get(API.COMPANY_DETAIL);
};
